module.exports = __webpack_public_path__ + "img/atoss.632cbd4c.svg";